<template>
    <div>
        <v-layout>
            <v-navigation-drawer permanent="true">
                <v-toolbar flat>
                    <v-list>
                        <v-list-tile>
                            <v-list-tile-title>
                                {{premise.name}}
                            </v-list-tile-title>
                        </v-list-tile>
                    </v-list>
                </v-toolbar>
                <v-divider></v-divider>
                <v-list dense class="pt-0">
                    <v-list-tile :to="{path:'/premise/'+$route.params.premiseId}">
                        <v-list-tile-content>
                            <v-list-tile-title>Premise Details</v-list-tile-title>
                        </v-list-tile-content>
                    </v-list-tile>
                    <v-list-tile :to="{path:'/premise/'+$route.params.premiseId+'/profile'}">
                        <v-list-tile-content>
                            <v-list-tile-title>Profiles</v-list-tile-title>
                        </v-list-tile-content>
                    </v-list-tile>
                </v-list>

            </v-navigation-drawer>
            <router-view></router-view>
        </v-layout>
    </div>
</template>

<script>
    import api from '@/api';

        export default {
            provide() {
                return {
                    premisePromise: () => {
                        return new Promise((resolve) => {
                            api.premise.get(this.$route.params.premiseId).then((premise) => {
                                this.premise = premise;
                                resolve(premise);
                            });
                        });
                    }
                }
            },
            data() {
                return {
                    premise : {}
                }
            },
        created() {

        },
        methods : {

        }
    }

</script>